<div [class]="'reservation-container pb-5 main-container ' + (reservationFormFontSize | fontSizeClass)">
    <div *ngIf="reservation != null && reservation.reservationDetails != null && (reservation.reservationDetails.reservationId != null || reservation.reservationDetails.tmpId != null)"
        id="reservation-form" class="list-item-group">
        <h2 *ngIf="walkIn" [lang]="lang" class="text-uppercase">{{ 'reservations.newWalkin' | translate | uppercase }}
        </h2>
        <h2 *ngIf="!walkIn" [lang]="lang" class="text-uppercase flex-font">
            {{ 'reservations.newReservation' | translate | uppercase }}
            <a class="btn-msg btn btn-sm py-1 px-2 btn-remove" [canWrite]="'Communication'"
                *ngIf="isCommunicationAvailable()" (click)="showCommunicationModal()">
                <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                    <path fill="currentColor"
                        d="M22 5.5H9C7.9 5.5 7 6.4 7 7.5V16.5C7 17.61 7.9 18.5 9 18.5H22C23.11 18.5 24 17.61 24 16.5V7.5C24 6.4 23.11 5.5 22 5.5M22 16.5H9V9.17L15.5 12.5L22 9.17V16.5M15.5 10.81L9 7.5H22L15.5 10.81M5 16.5C5 16.67 5.03 16.83 5.05 17H1C.448 17 0 16.55 0 16S.448 15 1 15H5V16.5M3 7H5.05C5.03 7.17 5 7.33 5 7.5V9H3C2.45 9 2 8.55 2 8S2.45 7 3 7M1 12C1 11.45 1.45 11 2 11H5V13H2C1.45 13 1 12.55 1 12Z" />
                </svg>
                {{ 'communication.message' | translate }}
            </a>
        </h2>

        <!-- status -->
        <div *ngIf="!isNew || !walkIn" [canRead]="'Status'" class="list-item-collapsible"
            [class.list-item-collapsible-has-value]="reservation.reservationDetails.reservationsStatus != null && reservation.reservationDetails.reservationsStatus.trim().length > 0">
            <a class="list-item-collapsible-header" [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined"
                data-bs-target="#collapsestatus" aria-expanded="false">
                <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.status' |
                    translate | uppercase}}</span>
                <span class="list-item-collapsible-selection flex-font"><img class="icon-status"
                        [attr.src]="'assets/images/' + statusToIcon(reservation.reservationDetails.reservationsStatus)">
                    {{ 'reservations.statuses.' + reservation.reservationDetails.reservationsStatus.toLowerCase() |
                    translate }}
                </span>
            </a>
            <div #collapsestatus id="collapsestatus" class="collapse" data-bs-parent="#reservation-form">
                <div class="list-item-collapsible-content">
                    <!-- relevant -->
                    <div class="row row-xs btn-radio-group">
                        <div *ngFor="let relevantStatus of relevantStatuses" class="col-12 col-sm-6">
                            <button class="btn btn-sec btn-sec-icon no-effect w-100"
                                (mousedown)="setStatus(relevantStatus.id)"
                                [class.active]="reservation.reservationDetails.reservationsStatus == relevantStatus.id"
                                data-bs-toggle="collapse" data-bs-target="#collapsestatus">
                                <img class="icon-status" [src]="relevantStatus.img">
                                {{ 'reservations.statuses.' + relevantStatus.id.toLowerCase() | translate }}
                            </button>
                        </div>
                    </div>

                    <!-- less relevant -->
                    <div id="field-status-collapse" class="row row-xs btn-radio-group mt-4" [class.collapse]="!isNew">
                        <div *ngFor="let lessRelevantStatus of lessReleventStatuses" class="col-12 col-sm-6">
                            <button class="btn btn-sec btn-sec-icon no-effect w-100"
                                (mousedown)="setStatus(lessRelevantStatus.id)"
                                [class.active]="reservation.reservationDetails.reservationsStatus == lessRelevantStatus.id"
                                data-bs-toggle="collapse" data-bs-target="#collapsestatus">
                                <img class="icon-status" [src]="lessRelevantStatus.img">
                                {{ 'reservations.statuses.' + lessRelevantStatus.id.toLowerCase() | translate }}
                            </button>
                        </div>
                    </div>

                    <a *ngIf="!isNew" class="d-block text-end text-sm py-2" data-bs-toggle="collapse"
                        data-bs-target="#field-status-collapse">
                        <span class="collapse-closed">{{ 'reservations.showAll' | translate }}</span>
                        <span class="collapse-open">{{ 'reservations.hideLessRelevant' | translate }}</span>
                    </a>
                </div>
            </div>
        </div>

        <!-- purpose -->
        <div [canRead]="'Purpose'" class="list-item-collapsible"
            [class.list-item-collapsible-has-value]="reservation.reservationDetails.purpose != null && reservation.reservationDetails.purpose.trim().length > 0">
            <a class="list-item-collapsible-header" [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined"
                data-bs-target="#collapsepurpose" aria-expanded="false">
                <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.purpose' |
                    translate | uppercase}}</span>
                <span class="list-item-collapsible-selection flex-font">{{ 'common.' +
                    reservation.reservationDetails.purpose.toLowerCase() | translate }}</span>
            </a>
            <div id="collapsepurpose" class="collapse" data-bs-parent="#reservation-form">
                <div class="list-item-collapsible-content">
                    <div class="btn-radio-group">
                        <button class="btn btn-sec" [class.active]="reservation.reservationDetails.purpose == 'Food'"
                            (click)="setPurpose('Food')" data-bs-toggle="collapse" data-bs-target="#collapsepurpose">{{
                            'common.food' | translate }}</button>
                        <button class="btn btn-sec" [class.active]="reservation.reservationDetails.purpose == 'Drink'"
                            (click)="setPurpose('Drink')" data-bs-toggle="collapse" data-bs-target="#collapsepurpose">{{
                            'common.drink' | translate }}</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- arrival date -->
        <div *ngIf="!isNew || !walkIn" [canRead]="'ArrivalDateTime'"
            class="list-item-collapsible list-item-collapsible-has-value"
            [class.list-item-collapsible-has-value]="reservation.reservationDetails.arrivalTime != null && reservation.reservationDetails.arrivalTime.trim().length > 0">
            <a class="list-item-collapsible-header" [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined"
                data-bs-target="#collapsearrivaldate" aria-expanded="false">
                <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.arrivalDate' |
                    translate | uppercase}}</span>
                <span class="list-item-collapsible-selection flex-font">{{reservation.reservationDetails.arrivalTime |
                    amDateFormat:'DD-MM-yyyy'}}</span>
            </a>
            <div #collapsearrivaldate id="collapsearrivaldate" class="collapse" data-bs-parent="#reservation-form">
                <div class="list-item-collapsible-content">
                    <div style="width: 195px">
                        <app-datepicker [modelAsString]="reservation.reservationDetails.arrivalTime"
                            (modelChange)="setArrivalDate($event)" (changeFromCalendar)="arrivalTimeChanged($event)">
                        </app-datepicker>
                    </div>
                </div>
            </div>
        </div>

        <!-- arrival time -->
        <div *ngIf="!isNew || !walkIn" [canRead]="'ArrivalDateTime'" id="list-item-arrivaltime"
            class="list-item-collapsible"
            [class.list-item-collapsible-has-value]="reservation.reservationDetails.arrivalTime != null && reservation.reservationDetails.arrivalTime.trim().length > 0">
            <a class="list-item-collapsible-header" [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined"
                data-bs-target="#collapsearrivaltime" aria-expanded="false">
                <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.arrivalTime' |
                    translate | uppercase}}</span>
                <span *ngIf="arrivalTime != null"
                    class="list-item-collapsible-selection flex-font">{{reservation.reservationDetails.arrivalTime |
                    amDateFormat:'HH:mm'}}</span>
            </a>
            <div id="collapsearrivaltime" class="collapse" data-bs-parent="#reservation-form">
                <div class="list-item-collapsible-content">
                    <ul class="nav btn-tab-group">
                        <li *ngFor="let shift of processedShifts" class="nav-item">
                            <a class="nav-link btn-tab" [id]="'#arrivaltime-' + shift.shiftId + '-tab'"
                                data-bs-toggle="tab" [class.active]="arrivalTimeSelectedShiftId == shift.shiftId"
                                [href]="'#arrivaltime-' + shift.shiftId" role="tab"
                                (click)="arrivalTimeSelectedShiftId = shift.shiftId">{{getShiftTitle(shift.type)}}</a>
                        </li>
                    </ul>
                    <div class="tab-content pt-4">
                        <div *ngFor="let shift of processedShifts" class="tab-pane fade" [id]="'arrivaltime-' + shift.shiftId"
                            [class.active]="arrivalTimeSelectedShiftId == shift.shiftId"
                            [class.show]="arrivalTimeSelectedShiftId == shift.shiftId" role="tabpanel">
                            <div class="row row-xs btn-radio-group" style="max-width:420px;">
                                <div *ngFor="let dayPart of shift.dayParts" class="col-3">

  <ng-container *ngIf="showAttendanceRateFeatures; else oldArrivalSlot">
    <a class="btn btn-sec px-0 w-100 arrival-slot-btn"
       href="javascript:void(0);"
       [class.active]="isDayPartSelected(reservation.reservationDetails.arrivalTime, dayPart)"
       [class.disabled]="isSlotDisabled(dayPart)"
       [class.slot-over-limit]="willSlotExceedAttendanceRate(dayPart)"
       (click)="onArrivalSlotClick(dayPart)"
       data-bs-toggle="collapse"
       [attr.data-bs-target]="isSlotDisabled(dayPart) ? null : '#collapsearrivaltime'">

      <span class="arrival-slot-time">
        {{ padZeros(dayPart.hours) }}:{{ padZeros(dayPart.minsFrom) }}
      </span>

      <ng-container *ngIf="getSlotSummary(dayPart) as slot">
        <small class="arrival-slot-stats">
          <ng-container *ngIf="slot.reservations > 0; else emptySlotStats">
            {{ slot.covers }}/{{ attendanceRate }}
            <br>
            R. {{ slot.reservations }}
          </ng-container>

          <ng-template #emptySlotStats>
            -/-
            <br>
            -
          </ng-template>
        </small>
      </ng-container>
    </a>
  </ng-container>

  <ng-template #oldArrivalSlot>
    <a class="btn btn-sec px-0 w-100"
       href="javascript:void(0);"
       [class.active]="isDayPartSelected(reservation.reservationDetails.arrivalTime, dayPart)"
       (click)="setArrivalTime(dayPart)"
       data-bs-toggle="collapse"
       data-bs-target="#collapsearrivaltime">
      {{ padZeros(dayPart.hours) }}:{{ padZeros(dayPart.minsFrom) }}
    </a>
  </ng-template>

</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- people -->
        <div [canRead]="'Covers'" id="list-item-people" class="list-item-collapsible"
            [class.list-item-collapsible-has-value]="reservation.reservationDetails.covers != null && reservation.reservationDetails.covers > 0">
            <a class="list-item-collapsible-header" [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined"
                data-bs-target="#collapsepeople" aria-expanded="false">
                <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.people' |
                    translate | uppercase}}</span>
                <span class="list-item-collapsible-selection flex-font">{{reservation.reservationDetails.covers}}</span>
            </a>
            <div id="collapsepeople" class="collapse" data-bs-parent="#reservation-form">
                <div class="list-item-collapsible-content">

                    <ul class="nav btn-tab-group">
                        <li class="nav-item">
                            <a class="nav-link btn-tab active" id="#people-tab" data-bs-toggle="tab" href="#people"
                                role="tab">{{'reservations.selectPeople' | translate}}</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link btn-tab" id="#people-manual-tab" data-bs-toggle="tab"
                                href="#people-manual" role="tab">{{'reservations.setManually' | translate}}</a>
                        </li>
                    </ul>
                    <div class="tab-content pt-4">
                        <div class="tab-pane fade show active" id="people" role="tabpanel">
                            <div class="row row-xs btn-radio-group">
                                <ng-container *ngFor="let hour of [].constructor(24); let i = index">
                                    <div class="col-3 col-sm-2 col-md-1">
                                        <a class="btn btn-sec px-0 w-100"
                                            [class.active]="reservation.reservationDetails.covers === i + 1"
                                            (click)="setCovers(i + 1)" data-bs-toggle="collapse"
                                            data-bs-target="#collapsepeople">
                                            {{i + 1}}
                                        </a>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="people-manual" role="tabpanel">
                            <div class="ihost-input-spinner-container">
                                <app-numberpicker [(model)]="covers"></app-numberpicker>
                                <button [lang]="lang" class="btn btn-main btn-submit text-uppercase"
                                    (click)="setCovers(covers)" data-bs-toggle="collapse"
                                    data-bs-target="#collapsepeople">{{ 'reservations.setManuallyButton' | translate |
                                    uppercase
                                    }}</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- online category -->
        <ng-container *ngIf="!isNew || !walkIn">
            <div *ngIf="(restaurantHasOnlineCategories$ | async)" id="list-item-online-category"
                class="list-item-collapsible"
                [class.list-item-collapsible-has-value]="reservation.reservationDetails.onlineCategory?.id != null">
                <a class="list-item-collapsible-header" [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined"
                    data-bs-target="#collapseonlinecategory" aria-expanded="false">
                    <span [lang]="lang"
                        class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.onlineCategory' |
                        translate | uppercase}}</span>
                    <span *ngIf="reservation.reservationDetails?.onlineCategory?.iconCaption != null"
                        class="list-item-collapsible-selection flex-font">
                        {{reservation.reservationDetails.onlineCategory?.iconCaption}}
                    </span>
                </a>
                <div id="collapseonlinecategory" class="collapse" data-bs-parent="#reservation-form">
                    <div class="list-item-collapsible-content">
                        <a *ngFor="let onlineCategory of onlineCategories"
                            class="d-flex align-items-center py-3 list-item-sm list-item-link"
                            [class.active]="reservation.reservationDetails.onlineCategory?.id == onlineCategory.id"
                            (click)="setOnlineCategory(onlineCategory)" data-bs-toggle="collapse"
                            data-bs-target="#collapseonlinecategory" aria-expanded="false">
                            <div class="btn-tag-group">
                                <label [style.background-color]="onlineCategory.iconColor"
                                    class="d-flex justify-content-center align-items-center mb-0 btn-tag-static btn-tag-static-fixed fw-bold">
                                    {{onlineCategory.iconCaption}}
                                </label>
                            </div>
                            <label class="mb-0 ms-4">{{onlineCategory.nameLocalized}}</label>
                        </a>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- table -->
        <div [canRead]="'Table'" id="list-item-table" class="list-item-collapsible"
            [class.list-item-disabled]="isTablesPanelDisabled()"
            [class.list-item-collapsible-has-value]="reservation.reservationDetails.allocatedTables != null && reservation.reservationDetails.allocatedTables.trim().length > 0">

            <a class="list-item-collapsible-header" [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined"
                data-bs-target aria-expanded="false" aria-controls="collapsetable"
                [attr.disabled]="isTablesPanelDisabled() ? true : null" (click)="fetchTablesAvailability()">
                <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.table' |
                    translate | uppercase}}</span>
                <span class="list-item-collapsible-selection overflow-visible flex-font">
                    {{reservation.reservationDetails.allocatedTables}}
                    <i *ngIf="isTablesPanelDisabled()" class="text-faded text-sm">{{ 'reservations.set' | translate }}
                        @if (!walkIn) {
                            <span class="option-arrival-time">{{ 'reservations.arrivalTime' | translate }}</span>&nbsp;
                        }
                        <span class="option-people">{{ 'reservations.people' | translate }}</span>
                    </i>
                </span>
            </a>
        </div>

        <ng-container *ngIf="!isNew || !walkIn">

            <!-- return time -->
            <div [canRead]="'ReturnTime'" class="list-item-collapsible list-item-optional" id="list-item-returntime"
                [class.list-item-collapsible-has-value]="reservation.reservationDetails.returnTime != null && reservation.reservationDetails.returnTime.trim().length > 0">
                <a class="list-item-collapsible-header" [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined"
                    data-bs-target="#collapsereturntime" aria-expanded="false">
                    <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.returnTime' |
                        translate | uppercase}}</span>
                    <span class="list-item-collapsible-selection overflow-visible flex-font">
                        <i *ngIf="isReturnTimeBeforeArrivalTime()" class="text-faded text-sm">{{
                            'reservations.returnTimeBeforeArrival' | translate }}
                            {{reservation.reservationDetails.arrivalTime |
                            amDateFormat:'HH:mm'}}
                        </i>
                        <a *ngIf="reservation.reservationDetails.returnTime != null && reservation.reservationDetails.returnTime.trim().length > 0"
                            class="btn btn-main mx-2" (click)="setReturnTime(null)" data-bs-toggle="collapse"
                            data-bs-target>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                class="bi bi-x" viewBox="0 0 16 16">
                                <path
                                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                            </svg>
                        </a>
                        {{reservation.reservationDetails.returnTime | amDateFormat:'HH:mm'}}
                    </span>
                </a>
                <div id="collapsereturntime" class="collapse" data-bs-parent="#reservation-form">
                    <div *ngIf="processedShifts != null" class="list-item-collapsible-content">
                        <div class="d-flex flex-wrap">
                            <div class="me-auto">
                                <ul class="nav btn-tab-group mb-3 mr-3">
                                    <li *ngFor="let shift of processedShifts" class="nav-item">
                                        <a class="nav-link btn-tab" [id]="'#returntime-' + shift.shiftId + '-tab'"
                                            data-bs-toggle="tab"
                                            [class.active]="returnTimeSelectedShiftId == shift.shiftId"
                                            (click)="returnTimeSelectedShiftId = shift.shiftId"
                                            [href]="'#returntime-' + shift.shiftId"
                                            role="tab">{{getShiftTitle(shift.type)}}</a>
                                    </li>
                                </ul>
                            </div>
                            <!-- <span class="text-faded text-sm"><i>* Arrival time
                            <strong>{{reservation.reservationDetails.arrivalTime |
                                amDateFormat:'HH:mm'}}</strong></i></span> -->
                        </div>
                        <div class="tab-content pt-3">
                            <div *ngFor="let shift of processedShifts" class="tab-pane fade"
                                [id]="'returntime-' + shift.shiftId"
                                [class.active]="returnTimeSelectedShiftId == shift.shiftId"
                                [class.show]="returnTimeSelectedShiftId == shift.shiftId" role="tabpanel">
                                <div class="row row-xs btn-radio-group" style="max-width:420px;">
                                    <ng-container *ngFor="let dayPart of shift.dayParts; let i = index">
                                        <div class="col-3">
                                            <a class="btn btn-sec px-0 w-100"
                                                [class.active]="isDayPartSelected(reservation.reservationDetails.returnTime, dayPart)"
                                                [class.disabled]="isDayPartBeforeArrivalTime(dayPart)"
                                                (click)="setReturnTime(dayPart)" data-bs-toggle="collapse"
                                                data-bs-target="#collapsereturntime">
                                                {{padZeros(dayPart.hours)}}:{{padZeros(dayPart.minsFrom)}}
                                            </a>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <h2 [lang]="lang" class="text-uppercase flex-font">{{'reservations.customerDetails.title' | translate | uppercase}}
            </h2>
            <!-- guest search -->
            <div #guestSearchContainer *ngIf="(showSearchByRoom || showSearchByBooking) && isNew" class="list-item list-item-collapsible guest-search-container">
                <div class="list-item-content">
                    <form class="search-component search-autocomplete">

                        <!-- Search mode -->
                        <div class="search-mode-container">
                            <label class="form-label me-3">
                                {{ 'reservations.customerDetails.searchBy' | translate }}:
                            </label>

                            <div class="d-inline-flex align-items-center gap-3">
                                <!-- radios go here -->
                                <div class="form-check form-check-inline" *ngIf="showSearchByRoom">
                                    <input class="form-check-input" type="radio" [(ngModel)]="searchGuestMode" name="searchGuestMode"
                                        [value]="'roomNo'" [ngModelOptions]="{ standalone: true }" id="searchByRoomGuest"
                                        (change)="onSearchModeChange('roomNo')">
                                    <label class="form-check-label" for="searchByRoomGuest">
                                        {{ 'reservations.customerDetails.searchByRoom' | translate }}
                                    </label>
                                </div>
    
                                <div class="form-check form-check-inline" *ngIf="showSearchByBooking">
                                    <input class="form-check-input" type="radio" [(ngModel)]="searchGuestMode" name="searchGuestMode"
                                        [value]="'bookingNo'" [ngModelOptions]="{ standalone: true }" id="searchByBookingGuest"
                                        (change)="onSearchModeChange('bookingNo')">
                                    <label class="form-check-label" for="searchByBookingGuest">
                                        {{ 'reservations.customerDetails.searchByBooking' | translate }}
                                    </label>
                                </div>
                              </div>
                            
                        </div>

                        <!-- Search row: input + button -->
                        <div class="d-flex align-items-center w-100">
                            <div class="search-container">
                                <input class="ihost-control" type="search" name="searchGuestTerm" [(ngModel)]="searchGuestTerm"
                                    [placeholder]="getSearchPlaceholder()" (focus)="guestDropdownOpen = true"
                                    [attr.disabled]="readOnlyMode ? 'disabled' : undefined">
                            
                                @if (showGuestSearchLoadingSpinner) {
                                <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" class="loading-spinner">
                                    <circle class="spin" cx="14" cy="14" fill="none" r="9" stroke-width="2" stroke="#607675"
                                        stroke-dasharray="40 140" stroke-linecap="round" />
                                </svg>
                                } @else {
                                <button *ngIf="searchGuestTerm != ''" class="btn-clear" type="button"
                                    (mousedown)="searchGuestTerm = ''">&times;</button>
                                }
                            </div>

                            <a #searchBtn *ngIf="!readOnlyMode" class="btn btn-main ms-4" href="javascript:void(0);"
                                [class.disabled]="showGuestSearchLoadingSpinner" (click)="!showGuestSearchLoadingSpinner && guestSearch()">
                                {{'reservations.customerDetails.searchPhoneOrName' | translate}}
                            </a>
                        </div>

                        <!-- Results -->
                        <ul class="autocomplete-dropdown" [attr.style]="guestDropdownOpen ? 'display: block' : ''">
                            <a *ngFor="let guest of guests | filter:filterGuests:[searchGuestTerm, searchGuestMode]" class="list-item-sm"
                                (mousedown)="setCustomer(guest)">
                                <div class="list-item-sm-content guests">
                                    <h6 class="guest-header-row">
                                        <span *ngIf="guest.boardType" class="customer-type-badge-dropdown"
                                            [attr.style]="'background-color: ' + getCustomerTypeColor(guest.boardType)">
                                            {{ guest.boardType }}
                                        </span>

                                        <span class="guest-header-name me-2 flex-font"
                                            [innerHTML]="(guest.surname ?? '') + ' ' + (guest.name ?? '') | highlightSearch:searchCustomerTerm">
                                        </span>

                                        <span class="guest-header-contact d-inline-block flex-font">
                                            {{guest.telephone ?? guest.mail}}
                                        </span>
                                    </h6>

                                    <p class="text-xs text-body text-500">
                                        <span [lang]="lang" class="d-inline-block text-faded text-uppercase flex-font">
                                            {{'reservations.customerDetails.numberOfAdults' | translate | uppercase}}
                                        </span>
                                        <span class="flex-font">{{guest.numberOfAdults}}</span>

                                        <span [lang]="lang" class="d-inline-block text-faded text-uppercase flex-font">
                                            {{'reservations.customerDetails.numberOfChildren' | translate | uppercase}}
                                        </span>
                                        <span class="flex-font">{{guest.numberOfChildren}}</span>

                                        <span [lang]="lang" class="d-inline-block text-faded text-uppercase flex-font">
                                            {{'reservations.customerDetails.arrivalDate' | translate | uppercase}}
                                        </span>
                                        <span class="flex-font">{{guest.arrivalDate}}</span>

                                        <span [lang]="lang" class="d-inline-block text-faded text-uppercase flex-font">
                                            {{'reservations.customerDetails.departureDate' | translate | uppercase}}
                                        </span>
                                        <span class="flex-font">{{guest.departureDate}}</span>
                                    </p>

                                    <div *ngIf="getMetadataEntries(guest.metadata).length > 0"
                                        class="guest-metadata text-xs text-body text-500 mt-1">
                                        <div *ngFor="let entry of getMetadataEntries(guest.metadata)" class="guest-metadata-row">
                                            <span class="guest-metadata-label d-inline-block text-faded text-uppercase flex-font me-1">
                                                {{ formatMetadataCaption(entry) }}:
                                            </span>

                                            <ng-container *ngIf="splitMetadataValue(entry.value).length > 1; else singleMetadataValue">
                                                <span *ngFor="let item of splitMetadataValue(entry.value)" class="readonly-metadata-chip">
                                                    {{ item }}
                                                </span>
                                            </ng-container>

                                            <ng-template #singleMetadataValue>
                                                <span class="guest-metadata-value flex-font">{{ entry.value }}</span>
                                            </ng-template>
                                        </div>
                                    </div>

                                </div>
                            </a>
                        </ul>

                    </form>
                </div>
            </div>
  
            <!-- customer search -->
            <div #customerSearchContainer class="list-item list-item-collapsible">
                <div class="list-item-content">
                    <form class="search-component search-autocomplete">
                        <div class="search-container">
                            <input class="ihost-control" type="search" name="searchCustomerTerm"
                                [(ngModel)]="searchCustomerTerm" (keyup)="customerSearch()"
                                (paste)="customerSearch(true)" (blur)="customersDropdownOpen = false"
                                (ngModelChange)="customerSearch()"
                                placeholder="{{'reservations.customerDetails.searchPhoneOrName' | translate}}..."
                                [attr.disabled]="readOnlyMode ? 'disabled' : undefined">
                            @if (showCustomerSearchLoadingSpinner) {
                            <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" class="loading-spinner">
                                <circle class="spin" cx="14" cy="14" fill="none"
                                    r="9" stroke-width="2" stroke="#607675"
                                    stroke-dasharray="40 140"
                                    stroke-linecap="round" />
                            </svg>
                            } @else {
                            <button *ngIf="searchCustomerTerm != ''" class="btn-clear" type="button"
                                (mousedown)="searchCustomerTerm = ''">&times;</button>
                            }
                        </div>
                        <a #addNewBtn *ngIf="!readOnlyMode" class="btn btn-main ms-4" href="javascript:void(0);"
                            (click)="addNewCustomer()">
                            {{'reservations.customerDetails.addNew' | translate}}
                        </a>
                        <ul class="autocomplete-dropdown" [attr.style]="customersDropdownOpen ? 'display: block' : ''">
                            <a *ngFor="let customer of customers | filter:filterCustomers:searchCustomerTerm" class="list-item-sm"
                                [class.selected]="reservation.customerDetails.customerId == customer.customerId"
                                (mousedown)="setCustomer(customer)">
                                <div class="list-item-sm-content">
                                    <h6 class="guest-header-row">
                                        <span *ngIf="customer.customerType && customer.customerType !== 'S'"
                                            class="customer-type-badge-dropdown"
                                            [attr.style]="'background-color: ' + getCustomerTypeColor(customer.customerType)">
                                            {{ customer.customerType }}
                                        </span>
                        
                                        <span class="guest-header-name me-2 flex-font"
                                            [innerHTML]="(customer.surname ?? '') + ' ' + (customer.name ?? '') | highlightSearch:searchCustomerTerm">
                                        </span>
                        
                                        <span class="guest-header-contact d-inline-block flex-font">
                                            {{ customer.telephone }}
                                        </span>
                                    </h6>
                        
                                    <p [canRead]="'LoadCustomerHistory'" class="text-xs text-body text-500">
                                        <span [lang]="lang" class="d-inline-block text-faded text-uppercase flex-font">
                                            {{'reservations.customerDetails.visits' | translate | uppercase}}
                                        </span>
                                        <span class="flex-font">{{customer.reservations_counter}}</span>&nbsp;&nbsp;&nbsp;
                        
                                        <span [lang]="lang" class="d-inline-block text-faded text-uppercase flex-font">
                                            {{'reservations.customerDetails.cancellations' | translate | uppercase}}
                                        </span>
                                        <span class="flex-font">{{customer.cancelled_counter}}</span>&nbsp;&nbsp;&nbsp;
                        
                                        <span [lang]="lang" class="d-inline-block text-faded text-uppercase flex-font">
                                            {{'reservations.customerDetails.noShows' | translate | uppercase}}
                                        </span>
                                        <span class="flex-font">{{customer.notshown_counter}}</span>
                                    </p>
                                </div>
                            </a>
                        </ul>
                    </form>

                    <div *ngIf="hasSelectedCustomer()" class="customer-block">
                        <hr class="my-4">
                        <p *ngIf="reservation.customerDetails.reservations_counter != null || reservation.customerDetails.cancelled_counter != null || reservation.customerDetails.notshown_counter != null"
                            [canRead]="'LoadCustomerHistory'" class="text-xs text-body text-500 mb-4">
                            <span *ngIf="reservation.customerDetails.reservations_counter != null" [lang]="lang"
                                class="d-inline-block text-faded text-uppercase flex-font">
                                {{'reservations.customerDetails.visits' | translate | uppercase}}
                            </span>
                            <span class="flex-font">{{reservation.customerDetails.reservations_counter}}</span>&nbsp;&nbsp;&nbsp;
                            <span *ngIf="reservation.customerDetails.cancelled_counter != null" [lang]="lang"
                                class="d-inline-block text-faded text-uppercase flex-font">
                                {{'reservations.customerDetails.cancellations' | translate | uppercase}}
                            </span>
                            <span class="flex-font">{{reservation.customerDetails.cancelled_counter}}</span>&nbsp;&nbsp;&nbsp;
                            <span *ngIf="reservation.customerDetails.notshown_counter != null" [lang]="lang"
                                class="d-inline-block text-faded text-uppercase flex-font">
                                {{'reservations.customerDetails.noShows' | translate | uppercase}}
                            </span>
                            <span class="flex-font">{{reservation.customerDetails.notshown_counter}}</span>
                        </p>
                        <div [canRead]="'Type'" class="form-col">
                            <label class="mb-2 text-uppercase flex-font">{{ 'reservations.customerDetails.customerType' |
                                translate | uppercase }}</label>
                           
                            <div class="dropdown ihost-dropdown ihost-replace-val mb-2">
                                <a class="dropdown-toggle flex-font" href="#" role="button" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    @if (reservation.customerDetails.customerType == null || reservation.customerDetails.customerType == '') {
                                        <i class="color-square color-square-sm"
                                            [attr.style]="'background-color: ' + getCustomerTypeColor(reservation.reservationDetails.reservationType)"></i>
                                        {{getCustomerTypeName(reservation.reservationDetails.reservationType)}}
                                    } @else {
                                        <i class="color-square color-square-sm"
                                            [attr.style]="'background-color: ' + getCustomerTypeColor(reservation.customerDetails.customerType)"></i>
                                        {{getCustomerTypeName(reservation.customerDetails.customerType)}}
                                    }
                                </a>
                                <div class="dropdown-menu">
                                    <a *ngFor="let customerType of customerTypes" class="dropdown-item"
                                        (click)="setCustomerType(customerType.value)">
                                        <i class="color-square color-square-sm"
                                            [attr.style]="'background-color: ' + customerType.color"></i>
                                        {{customerType.description}}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- surname -->
                        <div [canRead]="'FullName'" class="form-col">
                            <!--<p>{{reservation.customerDetails.surname}}</p> -->
                            <label [lang]="lang" class="text-uppercase flex-font">{{ 'reservations.customerDetails.surname' |
                                translate | uppercase }}</label>
                            <input [ngModel]="reservation.customerDetails.surname"
                                (ngModelChange)="setCustomerSurname($event)" required #name="ngModel" type="text"
                                class="ihost-control w-100 mb-2 flex-font"
                                placeholder="{{ 'reservations.customerDetails.placeholders.customerSurname' | translate }}..."
                                maxlength="100" />
                        </div>
                        <!-- name -->
                        <div [canRead]="'FullName'" class="form-col">
                            <!--<p>{{reservation.customerDetails.name}}</p> -->
                            <label [lang]="lang" class="text-uppercase flex-font">{{ 'reservations.customerDetails.name' |
                                translate | uppercase }}</label>
                            <input [ngModel]="reservation.customerDetails.name"
                                (ngModelChange)="setCustomerName($event)" required #name="ngModel" type="text"
                                class="ihost-control w-100 mb-2 flex-font"
                                placeholder="{{ 'reservations.customerDetails.placeholders.customerName' | translate }}..."
                                maxlength="100" />
                        </div>
                        <!-- phone -->
                        <div [canRead]="'Telephone'" class="form-col">
                            <!-- <p><a
                                    [attr.href]="'tel:' + reservation.customerDetails.telephone">{{reservation.customerDetails.telephone}}</a>
                            </p> -->
                            <label [lang]="lang" class="text-uppercase flex-font">{{ 'reservations.customerDetails.phoneNumber' |
                                translate | uppercase }}</label>
                            <input [ngModel]="reservation.customerDetails.telephone"
                                (ngModelChange)="setCustomerTelephone($event)" required #name="ngModel" type="tel"
                                class="ihost-control w-100 mb-2 flex-font"
                                placeholder="{{ 'reservations.customerDetails.placeholders.customerPhone' | translate }}..." />
                        </div>
                        <!-- email -->
                        <div [canRead]="'Mail'" class="form-col">
                            <!-- <p><a [attr.href]="'mailto:' + reservation.customerDetails.mail"
                                target="_blank">{{reservation.customerDetails.mail}}</a></p> -->
                            <label [lang]="lang" class="text-uppercase flex-font">{{ 'reservations.customerDetails.email' |
                                translate | uppercase }}</label>
                            <input [ngModel]="reservation.customerDetails.mail"
                                (ngModelChange)="setCustomerMail($event)" required #name="ngModel" type="text"
                                class="ihost-control w-100 mb-2 flex-font"
                                placeholder="{{ 'reservations.customerDetails.placeholders.customerEmail' | translate }}..."
                                maxlength="50" />
                        </div>
                        <!-- Room number -->
                        <div [canWrite]="'SearchByRoomNum'" class="form-col">
                            <label [lang]="lang" class="text-uppercase flex-font">
                                {{ 'reservations.customerDetails.roomNumber' | translate | uppercase }}
                            </label>
                            <input [ngModel]="reservation.reservationDetails.roomNumber" (ngModelChange)="setRoomNumber($event)"
                                #name="ngModel" type="text" class="ihost-control w-100 mb-2 flex-font"
                                placeholder="{{ 'reservations.customerDetails.roomNumber' | translate }}..." maxlength="20" />
                        </div>
                        
                        <!-- Booking ID -->
                        <div [canWrite]="'SearchByBookingId'" class="form-col">
                            <label [lang]="lang" class="text-uppercase flex-font">
                                {{ 'reservations.customerDetails.bookingId' | translate | uppercase }}
                            </label>
                            <input [ngModel]="reservation.reservationDetails.roomBookingId" (ngModelChange)="setRoomBookinId($event)"
                                #name="ngModel" type="text" class="ihost-control w-100 mb-2 flex-font"
                                placeholder="{{ 'reservations.customerDetails.bookingId' | translate }}..." maxlength="100" />
                        </div>

                        
                        <!-- notes -->
                        <div class="form-col">
                            <!-- <p>{{reservation.customerDetails.notes}}</p> -->
                            <ng-container
                                *ngIf="reservation.customerDetails.notes != null && reservation.customerDetails.notes.length > 0">
                                <label [lang]="lang" class="text-uppercase flex-font">{{ 'reservations.customerDetails.notes' |
                                    translate | uppercase }}</label>
                                <input [ngModel]="reservation.customerDetails.notes" required #name="ngModel"
                                    type="text" class="ihost-control disabled w-100 mb-2 flex-font"
                                    placeholder="{{ 'reservations.customerDetails.placeholders.customerNotes' | translate }}..."
                                    readonly />
                            </ng-container>
                        </div>

                        <!-- metadata -->
                        <div *ngIf="getMetadataEntries(reservation?.reservationDetails?.metadata).length > 0" class="form-col">
                            <label [lang]="lang" class="text-uppercase flex-font">
                                {{ 'reservations.customerDetails.pmsInfo' | translate | uppercase }}
                            </label>

                            <div class="readonly-metadata-block mt-2">
                                <div *ngFor="let entry of getMetadataEntries(reservation?.reservationDetails?.metadata)"
                                    class="readonly-metadata-row mb-1">
                                    <span class="readonly-metadata-label text-faded text-uppercase flex-font">
                                        {{ formatMetadataCaption(entry) }}:
                                    </span>

                                    <ng-container *ngIf="splitMetadataValue(entry.value).length > 1; else singleMetadataValueTpl">
                                        <span *ngFor="let item of splitMetadataValue(entry.value)" class="badge bg-light text-dark me-1">
                                            {{ item }}
                                        </span>
                                    </ng-container>

                                    <ng-template #singleMetadataValueTpl>
                                        <span class="flex-font">{{ entry.value }}</span>
                                    </ng-template>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="!isCustomerValid" class="error-label flex-font" role="alert">
                            {{customerErrorMessage}}
                        </div>
                        <!-- <a *ngIf="!readOnlyMode" class="btn btn-sm btn-main mt-4" (click)="showEditCustomerModal()">{{
                            'reservations.customerDetails.editCustomer' | translate }}</a> -->
                    </div>

                </div>
            </div>           

            <!-- customer tags -->
            <div *ngIf="showTags && hasSelectedCustomer()" [canRead]="'Tags'"
                class="list-item-collapsible list-item-tags list-item-optional">
                <a class="list-item-collapsible-header" (click)="showCustomerTagsModal()">
                    <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.customerTags'
                        | translate | uppercase }}</span>
                    <span class="list-item-collapsible-selection d-flex align-items-center pe-2">
                        <i *ngFor="let tag of uniqueReservationCustomerTagsByCategory"
                            class="tag color-dot color-dot-xs" [style.backgroundColor]="getTagColor(tag)"></i>
                        <!-- <app-tag-icon *ngFor="let tag of uniqueReservationCustomerTagsByCategory"
                            [color]="getTagColor(tag)" class="tag"></app-tag-icon> -->
                    </span>
                </a>
                <!-- <div #collapsecustomertags id="collapsecustomertags" class="collapse"
                    data-bs-parent="#reservation-form">
                    <div class="list-item-collapsible-content">
                        <app-tags [tagType]="'CUSTOMER'" [modalId]="'customer-tags'"
                            [tagCategories]="customerTagCategories" [selectedTags]="reservationCustomerTags"
                            (setTags)="setCustomerTags($event)"></app-tags>
                    </div>
                </div> -->
            </div>

            <!-- customer dietary restrictions -->
            <div *ngIf="showTags && hasSelectedCustomer()" [canRead]="'Tags'"
                class="list-item-collapsible list-item-tags list-item-optional">
                <a class="list-item-collapsible-header" (click)="showCustomerDietaryTagsModal()">
                    <span [lang]="lang"
                        class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.customerDietaryRestrictions'
                        | translate | uppercase }}</span>
                    <span class="list-item-collapsible-selection d-flex align-items-center pe-2">
                        <span class="list-item-collapsible-selection">
                            {{reservation.customerDetails.allergy}}
                        </span>
                        <i *ngFor="let tag of uniqueReservationCustomerDietaryTagsByCategory"
                            class="tag color-dot color-dot-xs" [style.backgroundColor]="getTagColor(tag)"></i>
                        <!-- <app-tag-icon *ngFor="let tag of uniqueReservationCustomerDietaryTagsByCategory"
                            [color]="getTagColor(tag)" class="tag"></app-tag-icon> -->
                    </span>
                </a>
                <!-- <div #collapsecustomerdietarytags id="collapsecustomerdietarytags" class="collapse"
                    data-bs-parent="#reservation-form">
                    <div class="list-item-collapsible-content">
                        <app-tags [tagType]="'CUSTOMER'" [modalId]="'customer-dietary-tags'"
                            [tagCategories]="customerDietaryTagCategories"
                            [selectedTags]="reservationCustomerDietaryTags" (setTags)="setCustomerDietaryTags($event)"
                            [displayCategoryLabel]="false" [displayAdditionalTextInput]="true"
                            [additionalTextInput]="reservation.customerDetails.allergy"
                            (setAdditionalTextInput)="setCustomerDietaryRestrictions($event)">
                        </app-tags>
                    </div>
                </div> -->
            </div>

            <h2 [lang]="lang" class="text-uppercase flex-font">{{'reservations.extraDetails' | translate | uppercase }}</h2>          

            <!-- notes -->
            <div [canRead]="'Notes'" class="list-item-collapsible list-item-optional"
                [class.list-item-collapsible-has-value]="reservation.reservationDetails.notes != null && reservation.reservationDetails.notes.trim().length > 0">
                <a class="list-item-collapsible-header" [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined"
                    data-bs-target="#collapsenotes" aria-expanded="false">
                    <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.notes' |
                        translate | uppercase }}</span>
                    <span class="list-item-collapsible-selection flex-font">{{reservation.reservationDetails.notes}}</span>
                </a>
                <div #collapsenotes id="collapsenotes" class="collapse" data-bs-parent="#reservation-form">
                    <div class="list-item-collapsible-content">
                        <textarea #reservationnotes class="ihost-control" name="reservationNotes"
                            placeholder="{{'reservations.typeReservationNotes' | translate}}"
                            [ngModel]="reservation.reservationDetails.notes" (change)="setNotes($event)"></textarea>
                        <!-- <a class="btn btn-xs btn-main mt-3" data-bs-toggle="collapse" data-bs-target="#collapsenotes"
                            aria-expanded="false" (click)="setNotes()">{{'reservations.done' | translate}}</a> -->
                    </div>
                </div>
            </div>

            <!-- reservation tags -->
            <div *ngIf="showTags" [canRead]="'Tags'" class="list-item-collapsible list-item-tags list-item-optional">
                <a class="list-item-collapsible-header" (click)="showReservationTagsModal()">
                    <span [lang]="lang"
                        class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.reservationTags' |
                        translate | uppercase }}</span>
                    <span class="list-item-collapsible-selection d-flex align-items-center pe-2">
                        <!-- <i *ngFor="let tag of uniqueReservationReservationTagsByCategory" class="color-dot color-dot-xs"
                            [style.backgroundColor]="getTagColor(tag)"></i> -->
                        <app-tag-icon *ngFor="let tag of uniqueReservationReservationTagsByCategory"
                            [color]="getTagColor(tag)" class="tag"></app-tag-icon>
                    </span>
                </a>
                <!-- <div #collapsereservationtags id="collapsereservationtags" class="collapse"
                    data-bs-parent="#reservation-form">
                    <div class="list-item-collapsible-content">
                        <app-tags [tagType]="'RESERVATION'" [modalId]="'reservation-tags'"
                            [tagCategories]="reservationTagCategories" [selectedTags]="reservationReservationTags"
                            (setTags)="setReservationTags($event)"></app-tags>
                    </div>
                </div> -->
            </div>

            <!-- dietary restrictions -->
            <div *ngIf="!showTags" [canRead]="'Allergies'" class="list-item-collapsible list-item-optional"
                [class.list-item-collapsible-has-value]="reservation.reservationDetails.allergy != null && reservation.reservationDetails.allergy.trim().length > 0">
                <a class="list-item-collapsible-header" [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined"
                    data-bs-target="#collapsedietaryrestrictions" aria-expanded="false">
                    <span [lang]="lang"
                        class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.dietaryRestrictions' |
                        translate | uppercase }}</span>
                    <span class="list-item-collapsible-selection">
                        {{reservation.reservationDetails.allergy}}
                    </span>
                </a>
                <div #collapsedietaryrestrictions id="collapsedietaryrestrictions" class="collapse"
                    data-bs-parent="#reservation-form">
                    <div class="list-item-collapsible-content">
                        <textarea #reservationdietaryrestrictions class="ihost-control"
                            name="reservationDietaryRestrictions"
                            placeholder="{{'reservations.typeDietaryRestrictions' | translate}}"
                            [ngModel]="reservation.reservationDetails.allergy"
                            (change)="setDietaryRestrictionsTemp($event)" maxlength="300"></textarea>
                        <!-- <a class="btn btn-xs btn-main mt-3" data-bs-toggle="collapse" data-bs-target="#collapsenotes"
                            aria-expanded="false" (click)="setNotes()">{{'reservations.done' | translate}}</a> -->
                    </div>
                </div>
            </div>

            <!-- reservation dietary restrictions -->
            <div *ngIf="showTags" [canRead]="'Tags'" class="list-item-collapsible list-item-tags list-item-optional">
                <a class="list-item-collapsible-header" (click)="showReservationDietaryTagsModal()">
                    <span [lang]="lang"
                        class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.reservationDietaryRestrictions'
                        | translate | uppercase }}</span>
                    <span class="list-item-collapsible-selection d-flex align-items-center pe-2">
                        <span class="list-item-collapsible-selection">
                            {{reservation.reservationDetails.allergy}}
                        </span>
                        <!-- <i *ngFor="let tag of uniqueReservationReservationDietaryTagsByCategory"
                            class="color-dot color-dot-xs" [style.backgroundColor]="getTagColor(tag)"></i> -->
                        <app-tag-icon *ngFor="let tag of uniqueReservationReservationDietaryTagsByCategory"
                            [color]="getTagColor(tag)" class="tag"></app-tag-icon>
                    </span>
                </a>
                <!-- <div #collapsereservationdietarytags id="collapsereservationdietarytags" class="collapse"
                    data-bs-parent="#reservation-form">
                    <div class="list-item-collapsible-content">
                        <app-tags [tagType]="'RESERVATION'" [modalId]="'reservation-dietary-tags'"
                            [tagCategories]="reservationDietaryTagCategories"
                            [selectedTags]="reservationReservationDietaryTags"
                            (setTags)="setReservationDietaryTags($event)" [displayCategoryLabel]="false"
                            [displayAdditionalTextInput]="true"
                            [additionalTextInput]="reservation.reservationDetails.allergy"
                            (setAdditionalTextInput)="setDietaryRestrictions($event)"></app-tags>
                    </div>
                </div> -->
            </div>

            <!-- sources -->
            <div #sourceSearchContainer [canRead]="'Source'" class="list-item-collapsible list-item-optional"
                [class.list-item-disabled]="reservation.sourceDetails?.sourceCategory == 'EB2CPLATFORM'">
                <a class="list-item-collapsible-header" [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined"
                    data-bs-target aria-expanded="false" aria-controls="collapsesources"
                    [attr.disabled]="reservation.sourceDetails?.sourceCategory == 'EB2CPLATFORM' ? true : null"
                    (click)="toggleSourcesPanel()">
                    <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.sources' |
                        translate | uppercase }}</span>
                    <span class="list-item-collapsible-selection flex-font">
                        <a *ngIf="sourceCaption != null && sourceCaption != '' && sourceCaption != '-' && reservation.sourceDetails?.sourceCategory != 'EB2CPLATFORM'"
                            class="btn btn-main mx-2" (click)="setSource(null)" data-bs-toggle="collapse"
                            data-bs-target>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                class="bi bi-x" viewBox="0 0 16 16">
                                <path
                                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                            </svg>
                        </a>
                        <span (click)="showEditSourceModal(reservation.sourceDetails);">{{sourceCaption}}</span>
                    </span>
                </a>
                <div #collapsesources id="collapsesources" class="collapse" data-bs-parent="#reservation-form">
                    <div *ngIf="reservation.sourceDetails?.sourceCategory != 'EB2CPLATFORM'"
                        class="list-item-collapsible-content">
                        <form class="search-component">
                            <div class="search-container">
                                <input class="ihost-control" name="searchSourcesTerm" type="search"
                                    [(ngModel)]="searchSourcesTerm"
                                    placeholder="{{'reservations.searchSources' | translate}}..."
                                    (keyup)="onSourceSearchTermChange()">
                                <button class="btn-clear" type="button"
                                    (click)="searchSourcesTerm = ''">&times;</button>
                            </div>
                            <a class="btn btn-transparent btn-new" href="javascript:void(0);"
                                (click)="showAddSourceModal()">{{'reservations.addNew' | translate}}</a>
                        </form>

                        <ul class="nav quick-nav">
                            <li><a data-bs-parent="#sources" data-target="#0-9"
                                    (click)="quickNavigateSources('0-9')">0-9</a>
                            <li><a data-bs-parent="#sources" data-href="#en"
                                    (click)="quickNavigateSources('en')">A-Z</a>
                            <li><a data-bs-parent="#sources" data-href="#gr"
                                    (click)="quickNavigateSources('gr')">Α-Ω</a>
                        </ul>

                        <div id="sources" #sources class="overflown-container">

                            <ng-container *ngFor="let languageGroup of sourceGroups | keyvalue">
                                <div [attr.id]="languageGroup.key">
                                    <ng-container
                                        *ngFor="let sourceGroup of languageGroup.value | keyvalue | filter:filterSourceGroups:searchSourcesTerm:filterSources">
                                        <div class="sticky-title">
                                            {{sourceGroup.key}}
                                        </div>
                                        <ng-container
                                            *ngFor="let source of sourceGroup.value | filter:filterSources:searchSourcesTerm">
                                            <div class="list-item-sm list-item-link">
                                                <a class="row-link" href="javascript:void(0);"
                                                    [class.active]="source.id == selectedSource?.id"
                                                    (click)="showEditSourceModal(source);" data-bs-toggle="collapse"
                                                    data-bs-target="#collapsesources" aria-expanded="false"></a>
                                                <div class="list-item-sm-content">
                                                    <h6>
                                                        {{source.companyTitle}} - <span
                                                            class="text-sm">{{source.contactSurname}}
                                                            {{source.contactName}}</span>
                                                    </h6>
                                                    <p class="text-sm"><a class="text-link-faded me-2"
                                                            [attr.href]="'mailto:' + source.contactEmail">{{source.contactEmail}}</a>
                                                        <a class="text-link-faded"
                                                            [attr.href]="'tel:' + source.contactPhone">{{source.contactPhone}}</a>
                                                    </p>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>

                        <!-- <a class="btn btn-xs btn-main mt-3" data-bs-toggle="collapse" data-bs-target="#collapsesources"
                            aria-expanded="false" (click)="setSource()">{{'reservations.done' | translate}}</a> -->
                    </div>
                </div>
            </div>

            <!-- bill -->
            <div [canRead]="'Bill'" class="list-item-collapsible list-item-optional"
                [class.list-item-collapsible-has-value]="reservation.reservationDetails.bill != null && reservation.reservationDetails.bill > 0">
                <a class="list-item-collapsible-header" [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined"
                    data-bs-target="#collapsebill" aria-expanded="false">
                    <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">{{'common.bill' |
                        translate | uppercase }}</span>
                    <span class="list-item-collapsible-selection flex-font">
                        {{reservation.reservationDetails.bill}}
                    </span>
                </a>
                <div id="collapsebill" class="collapse" data-bs-parent="#reservation-form">
                    <div class="list-item-collapsible-content">
                        <input type="number" class="ihost-control" name="reservationBill"
                            placeholder="{{'reservations.typeReservationBill' | translate}}"
                            [ngModel]="reservation.reservationDetails.bill" (change)="setBill($event)" min="0">
                    </div>
                </div>
            </div>

            <!-- extra info -->
            <div [canRead]="'FixMenu'" *ngIf="restaurantHasExtraInfo" class="list-item-collapsible list-item-optional">
                <a class="list-item-collapsible-header" [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined"
                    data-bs-target="#collapseextrainfo" aria-expanded="false">
                    <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.extraInfo' |
                        translate | uppercase }}</span>
                    <span class="list-item-collapsible-selection flex-font">{{reservation.reservationDetails.extraInfo}}</span>
                </a>
                <div id="collapseextrainfo" class="collapse" data-bs-parent="#reservation-form">
                    <div class="list-item-collapsible-content">
                        <app-dropdown [model]="reservation.reservationDetails.selectedMenu" [items]="menus"
                            [displayProperty]="'description'" [valueProperty]="'value'"
                            (onChange)="setExtraInfo($event)">
                        </app-dropdown>
                    </div>
                </div>
            </div>

            <!-- has cake -->
            <div [canRead]="'Cake'" class="list-item-collapsible list-item-optional">
                <a class="list-item-collapsible-header non-clickable" aria-expanded="false">
                    <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.cake' |
                        translate | uppercase }}</span>
                    <span class="list-item-collapsible-selection" style="cursor: pointer"
                        (click)="setHasCake(!reservation.reservationDetails.hasCake)">
                        <svg *ngIf="reservation.reservationDetails.hasCake" xmlns="http://www.w3.org/2000/svg"
                            width="24" height="24" fill="#607675" class="bi bi-check-square-fill" viewBox="0 0 16 16">
                            <path
                                d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" />
                        </svg>
                        <svg *ngIf="!reservation.reservationDetails.hasCake" xmlns="http://www.w3.org/2000/svg"
                            width="24" height="24" fill="#607675" class="bi bi-square" viewBox="0 0 16 16">
                            <path
                                d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                        </svg>
                    </span>
                </a>
                <!--<div id="collapsehascake" class="collapse" data-bs-parent="#reservation-form">
                    <div class="list-item-collapsible-content">
                        <app-checkbox [model]="reservation.reservationDetails.hasCake"
                            (modelChange)="setHasCake($event)"></app-checkbox>
                    </div>
                </div>-->
            </div>

            <!-- smoking area -->
            <div [canRead]="'SmokingArea'" class="list-item-collapsible list-item-optional">
                <!-- [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined"
                    data-bs-target="#collapsesmokingarea" -->
                <a class="list-item-collapsible-header non-clickable" aria-expanded="false">
                    <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.smokingArea'
                        | translate | uppercase }}</span>
                    <span class="list-item-collapsible-selection" style="cursor: pointer"
                        (click)="setSmokingArea(!reservation.reservationDetails.smokingArea)">
                        <svg *ngIf="reservation.reservationDetails.smokingArea" xmlns="http://www.w3.org/2000/svg"
                            width="24" height="24" fill="#607675" class="bi bi-check-square-fill" viewBox="0 0 16 16">
                            <path
                                d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" />
                        </svg>
                        <svg *ngIf="!reservation.reservationDetails.smokingArea" xmlns="http://www.w3.org/2000/svg"
                            width="24" height="24" fill="#607675" class="bi bi-square" viewBox="0 0 16 16">
                            <path
                                d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                        </svg>
                    </span>
                </a>
                <!--<div id="collapsesmokingarea" class="collapse" data-bs-parent="#reservation-form">
                    <div class="list-item-collapsible-content">
                        <app-checkbox [model]="reservation.reservationDetails.smokingArea"
                            (modelChange)="setSmokingArea($event)"></app-checkbox>
                    </div>
                </div>-->
            </div>

            <!-- fix menu -->
            <div [canRead]="'FixMenu'" *ngIf="!restaurantHasExtraInfo" class="list-item-collapsible list-item-optional">
                <!-- [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined"
                    data-bs-target="#collapsefixmenu" -->
                <a class="list-item-collapsible-header non-clickable" aria-expanded="false">
                    <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.fixMenu'
                        | translate | uppercase}}</span>
                    <span class="list-item-collapsible-selection" style="cursor: pointer"
                        (click)="setFixMenu(!reservation.reservationDetails.fixMenu)">
                        <svg *ngIf="reservation.reservationDetails.fixMenu" xmlns="http://www.w3.org/2000/svg"
                            width="24" height="24" fill="#607675" class="bi bi-check-square-fill" viewBox="0 0 16 16">
                            <path
                                d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" />
                        </svg>
                        <svg *ngIf="!reservation.reservationDetails.fixMenu" xmlns="http://www.w3.org/2000/svg"
                            width="24" height="24" fill="#607675" class="bi bi-square" viewBox="0 0 16 16">
                            <path
                                d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                        </svg>
                    </span>
                </a>
                <!--<div id="collapsefixmenu" class="collapse" data-bs-parent="#reservation-form">
                    <div class="list-item-collapsible-content">
                        <app-checkbox [model]="reservation.reservationDetails.fixMenu"
                            (modelChange)="setFixMenu($event)"></app-checkbox>
                    </div>
                </div>-->
            </div>

            <!-- discount -->
            <div [canRead]="'Discount'" class="list-item-collapsible list-item-optional"
                [class.list-item-collapsible-has-value]="hasDiscount()">
                <a class="list-item-collapsible-header" [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined"
                    data-bs-target="#collapsediscount" aria-expanded="false">
                    <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">{{'reservations.discount' |
                        translate | uppercase }}</span>
                    <span class="list-item-collapsible-selection flex-font">
                        {{reservation.reservationDetails.discount}}%
                    </span>
                </a>
                <div id="collapsediscount" class="collapse" data-bs-parent="#reservation-form">
                    <div class="list-item-collapsible-content">
                        <input type="number" class="ihost-control" name="reservationDiscount"
                            placeholder="{{'reservations.typeReservationDiscount' | translate}}"
                            [ngModel]="reservation.reservationDetails.discount" (change)="setDiscount($event)">
                    </div>
                </div>
            </div>

            <!-- payment link expiration date (nullable) [canRead]="'PaymentLinkExpiration'"  -->
            <div *ngIf="!isNew" class="list-item-collapsible list-item-collapsible-has-value" [canWrite]="'PaymentLinkExpiration'"
                [class.list-item-collapsible-has-value]="paymentLinkExpiresAt != null && paymentLinkExpiresAt.trim().length > 0">
            
                <a class="list-item-collapsible-header" (click)="onPaymentLinkExpirationToggle()"
                    [attr.data-bs-toggle]="!readOnlyMode ? 'collapse' : undefined" data-bs-target="#collapsePaymentLinkExpiration"
                    aria-expanded="false">
            
                    <span [lang]="lang" class="list-item-collapsible-label text-uppercase flex-font">
                        {{ 'reservations.paymentLinkExpiration' | translate | uppercase }}
                    </span>
            
                    <span class="list-item-collapsible-selection flex-font">
                        <ng-container
                            *ngIf="paymentLinkExpiresAt != null && paymentLinkExpiresAt.trim().length > 0; else noExpiration">
                            {{ paymentLinkExpiresAt | amDateFormat:'DD-MM-yyyy' }}
                        </ng-container>
                        <ng-template #noExpiration>
            
                        </ng-template>
                    </span>
                </a>
            
                <div #collapsePaymentLinkExpiration id="collapsePaymentLinkExpiration" class="collapse"
                    data-bs-parent="#reservation-form">
            
                    <div class="list-item-collapsible-content">
            
                        <!-- LOADING STATE -->
                        <div *ngIf="paymentLinkExpiresLoading" class="d-flex align-items-center" style="gap:10px;">
                            <div class="spinner-border spinner-border-sm text-secondary" role="status" aria-label="Loading"></div>
                            <span class="text-muted text-sm">{{ 'common.loading' | translate }}</span>
                        </div>
            
                        <!-- NORMAL STATE -->
                        <ng-container *ngIf="!paymentLinkExpiresLoading">
            
                            <div style="display:flex; align-items:flex-start; gap:12px;">
            
                                <ng-container *ngIf="paymentLinkDatepickerKey % 2 === 0; else dp2">
                                    <div style="width: 195px">
                                        <div class="datepicker-wrap">
                                            <app-datepicker [modelAsString]="paymentLinkExpiresAt ?? ''"
                                                (modelChange)="setPaymentLinkExpirationDate($event)">
                                            </app-datepicker>
            
                                            <!-- Placeholder overlay (only when empty) -->
                                            <div class="datepicker-placeholder"
                                                *ngIf="paymentLinkExpiresAt == null || paymentLinkExpiresAt.trim().length === 0">
                                                <span>DD-MM-YYYY</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
            
                                <ng-template #dp2>
                                    <div style="width: 195px">
                                        <div class="datepicker-wrap">
                                            <app-datepicker [modelAsString]="paymentLinkExpiresAt ?? ''"
                                                (modelChange)="setPaymentLinkExpirationDate($event)">
                                            </app-datepicker>
            
                                            <div class="datepicker-placeholder"
                                                *ngIf="paymentLinkExpiresAt == null || paymentLinkExpiresAt.trim().length === 0">
                                                <span>DD-MM-YYYY</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
            
                                <!-- Clear icon (only when has value) -->
                                <button
                                    *ngIf="!readOnlyMode && paymentLinkExpiresAt != null && paymentLinkExpiresAt.trim().length > 0"
                                    type="button" class="btn btn-icon button-clear" (click)="clearPaymentLinkExpirationDate()"
                                    aria-label="Clear payment link expiration">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-trash3" viewBox="0 0 16 16">
                                        <path
                                            d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                    </svg>
                                </button>
            
                            </div>
            
                            <!-- Hint only when empty -->
                            <div *ngIf="!readOnlyMode && (paymentLinkExpiresAt == null || paymentLinkExpiresAt.trim().length === 0)"
                                class="mt-2 text-muted" style="font-size: 12px;">
                                {{ 'reservations.paymentLinkExpirationHint' | translate }}
                            </div>
            
                        </ng-container>
            
                        <!-- ERROR (show regardless of loading state) -->
                        <div *ngIf="paymentLinkExpiresError" class="error-label flex-font mt-2" role="alert">
                            <!-- {{ paymentLinkExpiresError }} -->
                            {{ paymentLinkExpiresError | translate }}
                        </div>
            
                    </div>
                </div>
            </div>

            <!-- <app-tags [tagCategories]="customerTagCategories"></app-tags> -->
            <!-- <app-tags [tagCategories]="reservationDietaryTagCategories"></app-tags> -->
            <!-- <div *ngIf="showTags" class="list-item-collapsible list-item-tags list-item-optional">
                <a class="list-item-collapsible-header" data-bs-toggle="collapse"
                    data-bs-target="#collapsereservationtags" aria-expanded="false">
                    <span [lang]="lang"
                        class="list-item-collapsible-label text-uppercase">{{'reservations.reservationTags' |
                        translate | uppercase }}</span>
                    <span class="list-item-collapsible-selection d-flex align-items-center">
                        <i *ngFor="let tag of reservation.reservationDetails.reservationTags"
                            class="color-dot color-dot-xs" [style.backgroundColor]="getTagColor(tag)"></i>
                    </span>
                </a>
                <div id="collapsereservationtags" class="collapse" data-bs-parent="#reservation-form">
                    <div class="list-item-collapsible-content">
                        <form class="search-component">
                            <div class="search-container">
                                <input class="ihost-control" name="searchReservationTagsTerm" type="search"
                                    placeholder="Search tags..." [(ngModel)]="searchReservationTagsTerm">
                                <button class="btn-clear" type="button">&times;</button>
                            </div>
                            <a class="btn btn-transparent btn-new" href="javascript:void(0);"
                                (click)="showAddReservationTagModal()">{{'reservations.addNew' | translate}}</a>
                        </form>

                        <ng-container *ngFor="let tagCategory of reservationTagCategories">
                            <h3 *ngIf="tagCategory.tags != null && tagCategory.tags.length > 0" class="mt-4 mb-2">
                                {{tagCategory.name}} -
                                {{selectedTagsNumberByCategory(tagCategory)}}/{{tagCategory.tags.length}}</h3>
                            <div *ngIf="tagCategory.tags != null && tagCategory.tags.length > 0" class="btn-tag-group">
                                <label
                                    *ngFor="let tag of tagCategory.tags | filter:filterReservationTags:searchReservationTagsTerm"
                                    class="btn-tag" [style.backgroundColor]="tagCategory.color">
                                    <input [id]="'id' + tag.id" type="checkbox" [value]="tag.id"
                                        [checked]="reservationTags != null && hasReservationTag(tag)"
                                        (change)="toggleSelectReservationTag(tag)">
                                    <span>{{tag.title}}</span>
                                </label>
                            </div>
                        </ng-container>

                        <a class="btn btn-xs btn-main mt-3" data-bs-toggle="collapse"
                            data-bs-target="#collapsereservationtags" aria-expanded="false"
                            (click)="setReservationTags()">{{'reservations.done' |
                            translate}}</a>
                    </div>
                </div>
            </div> -->

            <br>

            <!-- created by -->
            <div *ngIf="!isNew" class="list-item">
                <div class="list-item-content">
                    <div [canRead]="'CreatedBy'" class="form-col">
                        <label [lang]="lang" class="text-uppercase flex-font">{{ 'reservations.createdBy' |
                            translate | uppercase }}</label>
                        <p class="flex-font">{{reservation.reservationDetails.createdBy}}</p>
                    </div>
                    <div [canRead]="'ConfirmedBy'" class="form-col">
                        <label [lang]="lang" class="text-uppercase flex-font">{{ 'reservations.confirmedBy' |
                            translate | uppercase }}</label>
                        <p class="flex-font">{{reservation.reservationDetails.confirmedBy}}</p>
                    </div>
                    <div [canRead]="'CreationTime'" class="form-col">
                        <label [lang]="lang" class="text-uppercase flex-font">{{ 'reservations.createdAt' |
                            translate | uppercase }}</label>
                        <p class="flex-font">{{reservation.reservationDetails.creationTime | amDateFormat:'DD/MM/YYYY HH:mm'}}</p>
                    </div>
                    <div class="form-col">
                        <label [lang]="lang" class="text-uppercase flex-font">{{ 'reservations.reservationId' |
                            translate | uppercase }}</label>
                        <p class="flex-font">{{reservation.reservationDetails.reservationId}}</p>
                    </div>

                    <div class="form-col" *ngIf="!isOffline && !readOnlyMode && (reservation.reservationDetails.tokenization || reservation.reservationDetails.deposit)">                         
                        <hr/>
                        <p>
                            <!-- Manual Charge -->
                            <a class="btn py-1 px-2 btn-main payment-btn" 
                            (click)="manualChargeModal.show()"
                            *ngIf="reservation.reservationDetails.tokenization"
                            [canWrite]="'ManualCharge'">
                            <svg class="pay-icon" fill="currentColor" height="16px" width="16px"  viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>credit-card</title> <path d="M28 5.25h-24c-1.518 0.002-2.748 1.232-2.75 2.75v16c0.002 1.518 1.232 2.748 2.75 2.75h24c1.518-0.002 2.748-1.232 2.75-2.75v-16c-0.002-1.518-1.232-2.748-2.75-2.75h-0zM2.75 10.75h26.5v2.5h-26.5zM4 6.75h24c0.69 0.001 1.249 0.56 1.25 1.25v1.25h-26.5v-1.25c0.001-0.69 0.56-1.249 1.25-1.25h0zM28 25.25h-24c-0.69-0.001-1.249-0.56-1.25-1.25v-9.25h26.5v9.25c-0.001 0.69-0.56 1.249-1.25 1.25h-0zM10 21.25h-4c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0h4c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0zM20 21.25h-6c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0h6c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0z"></path> </g></svg>
                            {{ 'payments.charge' | translate  }}</a>

                            <!-- Manual Refund -->
                            <a class="btn py-1 px-2 btn-remove payment-btn" 
                            *ngIf="(reservation.reservationDetails?.bill != null && reservation.reservationDetails.bill > 0) && (reservation.reservationDetails.deposit || reservation.reservationDetails.tokenization)"
                            (click)="manualRefundAmount = reservation.reservationDetails.bill; manualRefundModal.show()"
                            [canWrite]="'ManualRefund'">
                            <svg class="pay-icon" fill="currentColor" height="16px" width="16px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 206.108 206.108" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M152.774,69.886H30.728l24.97-24.97c3.515-3.515,3.515-9.213,0-12.728c-3.516-3.516-9.213-3.515-12.729,0L2.636,72.523 c-3.515,3.515-3.515,9.213,0,12.728l40.333,40.333c1.758,1.758,4.061,2.636,6.364,2.636c2.303,0,4.606-0.879,6.364-2.636 c3.515-3.515,3.515-9.213,0-12.728l-24.97-24.97h122.046c19.483,0,35.334,15.851,35.334,35.334s-15.851,35.334-35.334,35.334H78.531 c-4.971,0-9,4.029-9,9s4.029,9,9,9h74.242c29.408,0,53.334-23.926,53.334-53.334S182.182,69.886,152.774,69.886z"></path> </g></svg>
                            {{ 'payments.refund' | translate  }}</a>

                           <!-- Manual Reserve -->
                            <a class="btn py-1 px-2 btn-main payment-btn" (click)="openPreauthModal()"
                                *ngIf="reservation.reservationDetails.tokenization" [canWrite]="'ManualReserve'">
                                <svg class="pay-icon" fill="currentColor" height="16px" width="16px" viewBox="0 0 32 32"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M28 5.25h-24c-1.518 0.002-2.748 1.232-2.75 2.75v16c0.002 1.518 1.232 2.748 2.75 2.75h24c1.518-0.002 2.748-1.232 2.75-2.75v-16c-0.002-1.518-1.232-2.75-2.75-2.75h-0zM2.75 10.75h26.5v2.5h-26.5z" />
                                </svg>
                                {{ 'payments.reserve' | translate }}
                            </a>

                        </p>
                    </div>                   
                </div>
            </div>
          

            <p [canRead]="'LoadCustomerHistory'" [canWrite]="'AuditTrail'" *ngIf="!isNew"
                class="text-sm mt-3 mb-4 ps-4 flex-font">
                <a *ngIf="(reservationHistory$ | async) as reservationHistory" (click)="loadReservationHistory()">
                    {{ 'reservations.reservationHistory' | translate }}
                    <strong
                        *ngIf="reservationHistory != null && reservationHistory.length > 0">({{reservationHistory.length}})</strong>
                </a>
            </p>

        </ng-container>

        <div class="d-flex justify-content-center mt-4">
            @if (!isNew) {
                <button type="button" class="btn btn-main" (click)="createCopy()">{{'reservations.createCopyBtn' | translate }}</button>
            }
            <!-- @if (restaurants != null && restaurants.length > 0) {
                <button type="button" class="btn btn-main" (click)="showChangeRestaurantModal()">{{'reservations.changeRestaurantBtn' | translate }}</button>
            } -->
        </div>

    </div>
</div>

<div class="footer-fixed d-none">
    <div class="container p-2 d-flex align-items-center text-nowrap">
        <a href=# class="btn btn-main w-100">Submit Reservation</a>
        <a href=# class="btn btn-sm btn-transparent">Save for later</a>
    </div>
</div>

<div class="modal fade" id="table-info-modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
            <div [lang]="lang" class="modal-header text-uppercase">
                <h3>{{'reservations.tableInfoModal.title' | translate | uppercase }}</h3>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">&times;</button>
            </div>
            <div #tableinfomodalbody class="modal-body">
                <div class="clearfix">
                    <img src="assets/images/table_vector.svg" class="float-start me-2 mb-3" style="max-width:120px;">
                    <p>{{'reservations.tableInfoModal.introParagraph' | translate}}</p>
                </div>
                <ol class="ps-4">
                    <li class="mb-3">
                        <!--{{'reservations.tableInfoModal.theTableElement' | translate}}
                        <i>{{'reservations.tableInfoModal.header' | translate}}</i>
                        {{'reservations.tableInfoModal.shows' | translate}}
                        <strong>{{'reservations.tableInfoModal.tableNumber' | translate}}</strong>
                        {{'reservations.tableInfoModal.and' | translate}}
                        <strong>{{'reservations.tableInfoModal.capacity' | translate}}</strong>.-->
                        {{'reservations.tableInfoModal.firstParagraph' | translate}}
                    </li>
                    <li class="mb-3">
                        <!--{{'reservations.tableInfoModal.theTableElement' | translate}}
                        <i>{{'reservations.tableInfoModal.body' | translate}}</i>-->
                        {{'reservations.tableInfoModal.secondParagraph' | translate}}
                    </li>
                </ol>
                <p>{{'reservations.tableInfoModal.thirdParagraph' | translate}}</p>

                <p>
                    <i class="color-dot color-dot-sm bg-table-green"></i>
                    {{'reservations.tableInfoModal.recommendedTablesGreenColor' | translate}}
                    <br><i class="color-dot color-dot-sm bg-light-grey"></i>
                    <!--{{'reservations.tableInfoModal.tablesThat'
                    | translate}} <i>{{'reservations.tableInfoModal.might' | translate}}</i>
                    {{'reservations.tableInfoModal.beAGoodFitNeutralColor' | translate}}-->
                    {{'reservations.tableInfoModal.tablesGreyColor' | translate}}
                    <br><i class="color-dot color-dot-sm bg-table-red"></i>
                    {{'reservations.tableInfoModal.notIdealTables' | translate}}
                </p>
            </div>
            <div class="modal-footer">
                <small *ngIf="displayScrollDownMessage"
                    class="text-faded text-scroll-for-more"><i>{{'reservations.tableInfoModal.scrollDownForMore' |
                        translate}}</i></small>
                <button type="button" class="btn btn-main ms-auto"
                    data-bs-dismiss="modal">{{'reservations.tableInfoModal.done' | translate}}</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="reservation-history" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h3 [lang]="lang" class="d-flex flex-column">
                    <span class="text-uppercase mb-1">
                        {{'reservations.reservationHistory' | translate | uppercase }}
                    </span>
                    <span class="text-faded">
                        {{reservation.customerDetails.surname}}
                        {{reservation.customerDetails.name}}
                        {{reservation.reservationDetails.arrivalTime | amDateFormat:'DD-MM-yyyy, HH:mm'}}
                        {{reservation.reservationDetails.covers}}p
                    </span>

                </h3>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">&times;</button>
            </div>
            <div class="modal-body">
                <div *ngIf="(reservationHistory$ | async) as reservationHistory">
                    <div *ngFor="let auditTrail of reservationHistory" class="row-item">
                        <div class="d-flex align-items-center mb-1">
                            <h6 class="mb-0">
                                {{auditTrail.modifiedBy}}
                            </h6>
                            <span *ngIf="auditTrail.timeperformed"
                                class="ms-auto text-nowrap text-faded text-xs ps-2">{{millisecondsToDate(auditTrail.timeperformed)
                                | amDateFormat:'DD-MM-yyyy, HH:mm'}}</span>
                        </div>
                        <p class="d-flex flex-column text-sm">
                            <span [lang]="lang" class="text-uppercase text-faded">{{ 'reservations.auditTrail.' +
                                auditTrail.typeOfModification | translate | uppercase }}</span>
                            <!-- <span *ngFor="let diff of auditTrail.diffs" class="d-block">
                                {{diff.resField}} from {{diff.oldValue}} to {{diff.newValue}}
                            </span> -->
                            <span [innerHTML]="auditTrail.displayedDiffs"></span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-main ms-auto" data-bs-dismiss="modal">
                    {{'reservations.reservationHistoryDone' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>

<!-- add new source modal -->
<app-source-modal #sourceModal [selectedTag]="source" (onClose)="sourceModalClosed($event)"></app-source-modal>

<!-- tables modal -->
<app-modal-dialog #tablesModal [lang]="lang" title="{{'reservations.table' | translate | uppercase}}"
    titleClass="text-uppercase" modalId="tables-modal"
    okText="{{ 'reservations.customerDetails.saveCustomer' | translate }}" (onClose)="tablesModalClosed($event)">
    <div class="form-col">

        <div class="list-item-collapsible-content">

            <div id="table-title" [canWrite]="'LoadTablesPlan'" class="d-flex align-items-center">
                <ul *ngIf="tablesAvailability != null" class="nav btn-tab-group">
                    <li *ngFor="let section of tablesAvailability; let f = first;" class="nav-item">
                        <a class="nav-link btn-tab" [attr.id]="'#id-' + section.sectionId + '-tab'" [class.active]="f"
                            data-bs-toggle="tab" [attr.href]="'#id-' + section.sectionId"
                            role="tab">{{section.sectionName}}</a>
                    </li>
                </ul>
                <span class="text-sm ms-auto">
                    <!-- <a id="table-done-top" class="btn btn-xs btn-main" data-bs-toggle="collapse"
                                data-bs-target="#collapsetable" aria-expanded="false"
                                [class.disabled]="!isTablesSelectionValid()"
                                [attr.disabled]="!isTablesSelectionValid() ? true : null"
                                (click)="setAllocatedTables()">{{'reservations.done' | translate }}
                            </a> -->
                </span>
            </div>

            <div [canWrite]="'LoadTablesPlan'" class="d-flex align-items-center text-sm text-faded mt-3 mb-n1">
                <div>
                    <span class="d-inline-flex align-items-center">
                        <i class="color-dot color-dot-sm bg-table-green"></i><i>{{ 'reservations.recommended' |
                            translate }}</i>
                    </span>
                    <span class="d-inline-flex align-items-center ms-2">
                        <i class="color-dot color-dot-sm bg-table-red"></i><i>{{ 'reservations.seated' |
                            translate }}</i>
                    </span>
                </div>
                <!-- <a class="ms-3" data-bs-toggle="modal" data-bs-target="#table-info-modal"><span class="ihost-icon-info"
                        (click)="onShowTableInfoModal()"></span></a> -->
                <span class="ms-auto">
                    {{ 'reservations.allocated' | translate
                    }}&nbsp;{{seated}}/{{reservation.reservationDetails.covers}}
                </span>
            </div>

            <div [canWrite]="'LoadTablesPlan'" *ngIf="(tablesAvailability$ | async) as tablesAvailability"
                class="tab-content pt-4 ps-1 pe-1">
                <div *ngFor="let section of tablesAvailability; let f = first;" class="tab-pane fade show"
                    [attr.id]="'id-' + section.sectionId" [class.active]="f" role="tabpanel">
                    <div class="row row-xs btn-radio-group">
                        <div *ngFor="let table of section.sectionTables"
                            class="col-xxs-4 col-3 col-sm-2p4 col-md-1p5 btn-ihost-table-container">
                            <a class="btn-ihost-table" [class.ihost-table-green]="table.available && table.proposed"
                                [class.ihost-table-red]="!table.available"
                                [class.active]="table.tableName != null && allocatedTables.includes(table.tableName)"
                                (click)="toggleSelectTable(table)">
                                <span class="ihost-table-header">
                                    <h6>{{table.tableName}}</h6>
                                    <span
                                        class="text-xs text-faded">({{table.minCapacity}}-{{table.maxCapacity}})</span>
                                </span>
                                <span [canRead]="'TableSlots'" class="timeslot"
                                    [class.timeslot-conflict]="table.beforeAvailable == false">
                                    {{table.beforeArrival}}
                                    <small *ngIf="table.beforeReturn != ''"> {{table.beforeReturn}}</small>
                                </span>
                                <span [canRead]="'TableSlots'" class="timeslot">{{getTableSlot2Time(table)}}
                                    <small>{{getTableSlot2ReturnTime(table)}}</small>
                                </span>
                                <span [canRead]="'TableSlots'" class="timeslot"
                                    [class.timeslot-conflict]="table.afterAvailable == false">
                                    {{table.afterArrival}}
                                    <small *ngIf="table.afterReturn != ''"> {{table.afterReturn}}</small>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <textarea *ngIf="!hasLoadTablesPlanPermission()" class="ihost-control" name="reservationTables"
                placeholder="{{'reservations.typeReservationTables' | translate}}"
                [ngModel]="reservation.reservationDetails.allocatedTables"
                (change)="setAllocatedTablesText($event)"></textarea>

        </div>

    </div>
</app-modal-dialog>

<!-- reservation tags modal -->
<!-- <app-modal-dialog #reservationTagsModal [lang]="lang" title="{{'reservations.table' | translate | uppercase}}"
    titleClass="text-uppercase" modalId="reservation-tags-modal"
    okText="{{ 'reservations.customerDetails.saveCustomer' | translate }}" (onClose)="tablesModalClosed($event)">
    <div class="form-col">

        <div class="list-item-collapsible-content">
            <app-tags [tagType]="'RESERVATION'" [modalId]="'reservation-tags'"
                [tagCategories]="reservationTagCategories" [selectedTags]="reservationReservationTags"
                (setTags)="setReservationTags($event)"></app-tags>
        </div>

    </div>
</app-modal-dialog> -->

<!-- reservation tags -->
<app-tags-modal #reservationTagsModal modalId="reservationTagsModal" [tagCategories]="reservationTagCategories"
    [selectedTags]="reservationReservationTags" (setTags)="setReservationTags($event)">
</app-tags-modal>

<!-- reservation dietary tags -->
<app-tags-modal #reservationDietaryTagsModal modalId="reservationDietaryTagsModal"
    [tagCategories]="reservationDietaryTagCategories" [selectedTags]="reservationReservationDietaryTags"
    (setTags)="setReservationDietaryTags($event)" [displayCategoryLabel]="false" [displayAdditionalTextInput]="true"
    [additionalTextInput]="reservation.reservationDetails.allergy"
    (setAdditionalTextInput)="setDietaryRestrictions($event)">
</app-tags-modal>

<!-- customer tags -->
<app-tags-modal #customerTagsModal modalId="customerTagsModal" [tagCategories]="customerTagCategories"
    [selectedTags]="reservationCustomerTags" [tagType]="'CUSTOMER'" (setTags)="setCustomerTags($event)">
</app-tags-modal>

<!-- customer dietary tags -->
<app-tags-modal #customerDietaryTagsModal modalId="customerDietaryTagsModal"
    [tagCategories]="customerDietaryTagCategories" [selectedTags]="reservationCustomerDietaryTags"
    [tagType]="'CUSTOMER'" (setTags)="setCustomerDietaryTags($event)" [displayCategoryLabel]="false"
    [displayAdditionalTextInput]="true" [additionalTextInput]="reservation.customerDetails.allergy"
    (setAdditionalTextInput)="setCustomerDietaryRestrictions($event)">
</app-tags-modal>

<app-communication-modal *ngIf="reservation?.customerDetails != null" #communicationModal
    [reservation]="reservation"></app-communication-modal>

<app-modal-dialog #notAvailableTablesConfirmationModal title="{{'common.alert' | translate}}" modalId="notAvailableTables-confirmation-modal"
    okText="{{ 'common.buttons.continue' | translate }}" [isValid]="true" [hasCancel]="true"
    (onClose)="onCloseNotAvailableTablesConfirmation($event)">
    <div class="form-col">
        <span>{{ 'reservations.validationMessages.notAvailableTables' | translate: {tables: notAvailableTableNames}
            }}</span>
    </div>
</app-modal-dialog>

<app-modal-dialog #manualChargeModal title="{{ 'payments.charge' | translate  }}" modalId="manual-charge-modal"
(onClose)="charge($event)"
okText="{{ 'common.buttons.continue' | translate }}" [isValid]="true" [hasCancel]="true">
    <div class="form-col">
        <label>{{ 'payments.amount' | translate }}</label>
        <input type="number" class="ihost-control amount-input"
        [(ngModel)]="manualChargeAmount"
         min="1">
    </div>
</app-modal-dialog>

<app-modal-dialog #manualRefundModal title="{{ 'payments.refund' | translate  }}" modalId="manual-refund-modal"
(onClose)="refund($event)"
    okText="{{ 'common.buttons.continue' | translate }}" [isValid]="true" [hasCancel]="true">
    <div class="form-col">
        <label>{{ 'payments.amount' | translate }}</label>
        <input type="number" class="ihost-control amount-input"
        [(ngModel)]="manualRefundAmount"
         min="1">
    </div>
</app-modal-dialog>

<app-modal-dialog
  #manualReserveModal
  dialogClass="modal-xl"
  title="{{ 'payments.reserve' | translate }}"
  modalId="manual-reserve-modal"
  [errorMessage]="'payments.invalidAmount' | translate"
  (onClose)="reserve($event)"
  okText="{{ 'common.buttons.continue' | translate }}"
  [isValid]="(manualReserveAmount > 0 && manualReserveAmount < 1000)"
  [hasCancel]="true"
  [hasOk]="!preauthLoading && !hasEffectiveActiveHold && (preauthInfo?.CanReserve ?? true)">

  <!-- Overall loading -->
<div *ngIf="preauthInitialLoading"
     class="d-flex flex-column align-items-center justify-content-center"
     style="min-height: 220px;">
  <div class="text-muted mb-3">
    {{ 'payments.loadingPreauthHistory' | translate }}
  </div>
  <div class="spinner-border" style="width: 3rem; height: 3rem; color:#607675;" role="status" aria-label="Loading"></div>
</div>

  <ng-container *ngIf="!preauthInitialLoading">

    <!-- =========================
         Section 1: History
         ========================= -->
    <div class="preauth-section">
      <div class="preauth-section-title">
        {{ 'payments.historyTitle' | translate }}
      </div>

    <div *ngIf="preauthListLoading && !preauthInitialLoading" class="text-muted">
        {{ 'payments.loadingPreauthHistory' | translate }}
    </div>

      <div *ngIf="!preauthListLoading && (preauthItems?.length ?? 0) === 0" class="text-muted">
        {{ 'payments.noPreauthHistory' | translate }}
      </div>

      <div *ngIf="!preauthListLoading && (preauthItems?.length ?? 0) > 0" class="table-responsive">
        <table class="table table-sm align-middle">
          <thead>
            <tr>
              <th style="white-space: nowrap;">{{ 'payments.created' | translate }}</th>
              <th  style="white-space: nowrap;">{{ 'payments.amount' | translate }}</th>
              <th style="white-space: nowrap;">{{ 'payments.preauthStatus' | translate }}</th>
              <th style="white-space: nowrap;">{{ 'payments.captureBefore' | translate }}</th>
              <th class="text-end" style="white-space: nowrap;">{{ 'payments.actions' | translate }}</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of preauthItems" [class.table-warning]="isHoldActionable(item)">
              <td style="white-space: nowrap;">
                <span *ngIf="item?.Created != null; else dashCreated">
                  {{ (item.Created! * 1000) | date:'dd/MM/yyyy, HH:mm' }}
                </span>
                <ng-template #dashCreated>-</ng-template>
              </td>

              <td  style="white-space: nowrap;">
                {{ formatMoney(item?.Amount, item?.Currency) }}
              </td>

                <td style="white-space: nowrap;">
                    <span class="badge bg-warning text-dark me-2" *ngIf="isHoldActionable(item)">
                        {{ 'payments.activeHold' | translate }}
                    </span>
                    <span *ngIf="!isHoldActionable(item)">
                        <span class="badge bg-danger text-white me-2" *ngIf="isPaymentFailed(item)">
                            {{ 'payments.status.requires_payment_method' | translate }}
                        </span>
                        <span *ngIf="!isPaymentFailed(item)">
                            {{ getPreauthStatusLabel(item?.Status) }}
                        </span>
                    </span>
                </td>

              <td style="white-space: nowrap;">
                <span *ngIf="item?.CaptureBefore != null; else dashCb">
                  {{ (item.CaptureBefore! * 1000) | date:'dd/MM/yyyy HH:mm' }}
                </span>
                <ng-template #dashCb>-</ng-template>
              </td>

              <td class="text-end" style="white-space: nowrap;">
                <!-- Capture / Release only for active hold -->
                <ng-container *ngIf="isHoldActionable(item)">
                  <button class="btn btn-main py-1 px-2 me-2 btn-capture"
                          type="button"
                          [disabled]="preauthActionLoading"
                          (click)="openConfirmation('capture', item?.PaymentIntentId)">
                    {{ 'payments.capture' | translate }}
                  </button>

                  <button class="btn btn-sec py-1 px-2 me-2 btn-release"
                          type="button"
                          [disabled]="preauthActionLoading"
                          (click)="openConfirmation('release', item?.PaymentIntentId)">
                    {{ 'payments.release' | translate }}
                  </button>
                </ng-container>

                <!-- Refund only if captured AND not fully refunded -->
                <ng-container *ngIf="isRefundable(item)">
                  <button class="btn btn-main py-1 px-2 me-2 btn-refund"
                          type="button"
                          [disabled]="preauthActionLoading"
                          (click)="openConfirmation('refund', item?.PaymentIntentId)">
                    {{ 'payments.refund' | translate }}
                  </button>
                </ng-container>

                <!-- Fully refunded badge -->
                <span
                  *ngIf="(item?.Refunded === true) || ((item?.AmountRefunded ?? 0) >= (item?.Amount ?? 0) && (item?.Amount ?? 0) > 0)"
                  class="badge bg-secondary">
                  {{ 'payments.fullyRefunded' | translate }}
                </span>

                <!-- No actions -->
                <span *ngIf="!isHoldActionable(item) && !isRefundable(item)" class="text-muted"></span>
              </td>
            </tr> <!-- ✅ important closing tag -->
          </tbody>
        </table>
      </div>
    </div>

    <!-- =========================
         Section 2: New preauth
         ========================= -->
    <div class="preauth-section mt-3" *ngIf="!hasEffectiveActiveHold">
      <div class="preauth-section-title">
        {{ 'payments.newTitle' | translate }}
      </div>

      <div *ngIf="(preauthInfo?.CanReserve ?? true)" class="form-col">
        <label>{{ 'payments.amount' | translate }}</label>
        <input type="number"
               class="ihost-control amount-input"
               [(ngModel)]="manualReserveAmount"
               min="1">
      </div>
<div *ngIf="(preauthInfo?.CanReserve ?? true) === false" class="text-muted">
    <small>{{ 'payments.reserveBlocked' | translate }}</small>
</div>
    </div>

  </ng-container>
</app-modal-dialog>

<app-modal-dialog 
 #manualReserveConfirmationModal
 title="{{manualReserveConfirmation?.title}}" 
 [static]="true"
 modalId="manual-reserve-confirmation-modal"
 okText="{{ 'common.buttons.continue' | translate }}" 
 [isValid]="true" 
 [hasOk]="true" 
 [hasCancel]="true"
(onClose)="onCloseConfirmation($event)">
    <div class="form-col">
        <p>{{manualReserveConfirmation?.template}}</p>
    </div>
</app-modal-dialog>

<app-modal-dialog #changeRestaurantModal title="{{ 'reservations.changeRestaurantModalTitle' | translate  }}" modalId="change-restaurant-modal"
(onClose)="changeRestaurant($event)"
    okText="{{ 'common.buttons.continue' | translate }}" [isValid]="true" [hasCancel]="true">
    <div class="form-col">
        <label>{{ 'reservations.restaurant' | translate }}</label>
        <app-dropdown [(model)]="selectedRestaurant" [items]="restaurants"
            [displayProperty]="'display'" [valueProperty]="'value'" [readonly]="isOffline">
        </app-dropdown>
    </div>
</app-modal-dialog>